<script>
  import Vue from 'vue'
  import { mapGetters } from 'vuex'

  export default {
    props: ['messages'],
    mounted () {
//      clearInterval(messageTimer)
      var _this = this
//      messageTimer = setInterval(function () {
//          _this.gcapi('retrieveMyLeaveMessages').then((response) => {
//
//          })
//      }, 6 * 1000)
      _this.realmessages = _this.messages
      const retrieveMessage = function () {
        console.log('invoked')
        _this.gcapi('retrieveMyLeaveMessages').then((response) => {
          var data = response.body.result.merchantMessages
          for (var i in data) {
            if (data[i].merchantNo === _this.messages[0].merchantNo) {
              _this.realmessages = data[i].messages

              var len = _this.realmessages.length

              if (len > 0 && _this.messages[0].merchantNo === '101') {
                var lastMsg = _this.realmessages[len - 1]
                var now = new Date().getTime()
                var lastMsgDate = lastMsg.createDT

                if (lastMsgDate) {
                  var lastMsgTime = Date.parse(lastMsgDate)
                  var offset = now - lastMsgTime
                  if (offset < 3600 * 1000 && offset > 10) {
                    var autoMsg = {}
                    autoMsg.message = '如果信息长时间未回复，您可以选择添加技术支持微信：15000205412（电话同号）'
                    autoMsg.messageType = 2
                    _this.realmessages[len] = autoMsg
                  }
                }
              }

              if (data[i].unreadMessagesAmount > 0) {
                _this.gcapi('readLeaveMessageResponse', _this.messages[0].merchantNo)
              }
            }
          }
        })
      }
      retrieveMessage()
      _this.messageTimer = setInterval(retrieveMessage, 8 * 1000)
    },
    destroyed () {
      clearInterval(this.messageTimer)
    },
    methods: {
    },
    data () {
      return {
        realmessages: [],
        messageTimer: 0
      }
    },
    computed: {
      // 使用对象展开运算符将 getters 混入 computed 对象中
      ...mapGetters([
        'customerName',
        'curMessageSession'
        // ...
      ])
    },
    filters: {
      // 将日期过滤为 hour:minutes
      time (date) {
        if (typeof date === 'string') {
          date = new Date(date)
        }
        return date.getHours() + ':' + date.getMinutes()
      }
    },
    directives: {
      // 发送消息后滚动到底部
      'scroll-bottom' (el) {
        Vue.nextTick(() => {
          el.scrollTop = el.scrollHeight - el.clientHeight
        })
      }
    }
  }
</script>

<template>
  <div class="message" v-scroll-bottom="messages">
    <ul v-if="realmessages">
      <li v-for="item in realmessages">
        <p class="time" v-if="item.createDT">
          <span>{{ item.createDT }}</span>
        </p>
        <div class="main" :class="{ self: item.messageType===1 }">
          <img class="avatar" width="30" height="30" :src="item.messageType===1 ? '/emktResources/resocurces/img/user.jpg' : '/emktResources/resocurces/img/customerService.jpeg'" />
          <div class="text">{{ item.message }} <a v-if="item.merchandise" v-bind:href="'#/detail/merchandises?id='+ item.merchandise.merchandiseId">{{ item.merchandise.merchandiseLabel }}</a></div>
        </div>
      </li>
    </ul>
    <ul v-else>
      <li v-for="item in messages">
        <p class="time" v-if="item.createDT">
          <span>{{ item.createDT }}</span>
        </p>
        <div class="main" :class="{ self: item.messageType===1 }">
          <img class="avatar" width="30" height="30" :src="item.messageType===1 ? '/emktResources/resocurces/img/user.jpg' : '/emktResources/resocurces/img/customerService.jpeg'" />
          <div class="text">{{ item.message }} <a v-if="item.merchandise" v-bind:href="'#/detail/merchandises?id='+ item.merchandise.merchandiseId">{{ item.merchandise.merchandiseLabel }}</a></div>
        </div>
      </li>
    </ul>
  </div>
</template>

<style lang="less" scoped>
  .message {
    padding: 0.6rem 0.8rem;
    overflow-y: scroll;
  ul {
    margin: 0;
    padding: 0;
    list-style: none;
  }
  li {
    margin-bottom: 0.8rem;
  }
  .time {
    margin: 0.6rem 0;
    text-align: center;
  > span {
      display: inline-block;
      padding: 0 1rem;
      font-size: 0.8rem;
      color: #fff;
      border-radius: 0.2rem;
      background-color: #dcdcdc;
    }
  }
  .avatar {
    float: left;
    margin: 0 0.6rem 0 0;
    border-radius: 0.2;
  }
  .text {
    display: inline-block;
    position: relative;
    padding: 0 0.4rem;
    max-width: ~'calc(100% - 4rem)';
    min-height: 2.0rem;
    line-height: 2.5;
    font-size: 0.6rem;
    text-align: left;
    word-break: break-all;
    background-color: #fafafa;
    border-radius: 0.2rem;
  &:before {
     content: " ";
     position: absolute;
     top: 0.5rem;
     right: 100%;
     border: 0.3rem solid transparent;
     border-right-color: #fafafa;
   }
  }
  .self {
    text-align: right;
  .avatar {
    float: right;
    margin: 0 0 0 0.6rem;
  }
  .text {
    background-color: #b2e281;
  &:before {
     right: inherit;
     left: 100%;
     border-right-color: transparent;
     border-left-color: #b2e281;
   }
  }
  }
  }
</style>



// WEBPACK FOOTER //
// MessageContent.vue?140f7fc6